import { Route, Routes } from "react-router-dom";
import "./App.css";
import LLSWidget from "./components/LLSWidget";
import Widget from "./components/ChatWidget/Widget";
import LLM from "./components/LLM";
import ApiWidget from "./components/ChatWidget/ApiWidget";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import ChatMeetWidget from "./components/ChatMeetWidget/index";
import TestWidget from "./components/TestWidget";
import NewApiWidget from "./components/TestWidget/NewApiWidget";
//  to push
function App() {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  return (
    <div className="App">
      <Routes>
        {/* france college fair */}

        <Route
          path="/widget-esce"
          element={
            <ChatMeetWidget
              chatLink={"/widget-esce-chat"}
              headerBg="#FFFFFF"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "black",
              }}
              welcomeMsg="Welcome to ESCE Business School!"
              subheadingStyle={{
                color: "black",
              }}
            />
          }
        />
        <Route
          path="/widget-esce-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                    color: "black"
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "black" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="white"
            />
          }
        />
        {/* esdes */}
        <Route
          path="/widget-esdes"
          element={
            <ChatMeetWidget
              chatLink={"/widget-esdes-chat"}
              headerBg="#00758d"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to ESDES!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-esdes-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#00758d"
            />
          }
        />
        {/* tbs-education */}
        <Route
          path="/widget-tbs-education"
          element={
            <ChatMeetWidget
              chatLink={"/widget-tbs-education-chat"}
              headerBg="#f24e58"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to TBS Education!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-tbs-education-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#f24e58"
            />
          }
        />
        {/* grenoble-em */}
        <Route
          path="/widget-grenoble-em"
          element={
            <ChatMeetWidget
              chatLink={"/widget-grenoble-em-chat"}
              headerBg="#FFFFFF"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "black",
              }}
              welcomeMsg="Welcome to GEM!"
              subheadingStyle={{
                color: "black",
              }}
            />
          }
        />
        <Route
          path="/widget-grenoble-em-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#00758d"
            />
          }
        />
        {/* ieseg */}
        <Route
          path="/widget-ieseg"
          element={
            <ChatMeetWidget
              chatLink={"/widget-ieseg-chat"}
              headerBg="#FFFFFF"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "black",
              }}
              welcomeMsg="Welcome to IESEG!"
              subheadingStyle={{
                color: "black",
              }}
            />
          }
        />
        <Route
          path="/widget-ieseg-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                    color: "black",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "black" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#FFFFFF"
            />
          }
        />
        {/* neoma-bs */}
        <Route
          path="/widget-neoma-bs"
          element={
            <ChatMeetWidget
              chatLink={"/widget-neoma-bs-chat"}
              headerBg="#FFFFFF"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "black",
              }}
              welcomeMsg="Welcome to NEOMA Business School!"
              subheadingStyle={{
                color: "black",
              }}
            />
          }
        />
        <Route
          path="/widget-neoma-bs-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#FFFFFF"
            />
          }
        />
        {/* wayne */}
        <Route
          path="/widget-wayne"
          element={
            <ChatMeetWidget
              chatLink={"/widget-wayne-chat"}
              headerBg="linear-gradient(180deg,#093f39,#0c5449)"
              isGradient={true}
              logo="/wayne-logo.png"
              logoStyles={{ width: "295px", marginLeft: "-14px" }}
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to Wayne Law!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-wayne-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="linear-gradient(180deg,#093f39,#0c5449)"
            />
          }
        />
        {/* imt-bs */}
        <Route
          path="/widget-imt-bs"
          element={
            <ChatMeetWidget
              chatLink={"/widget-imt-bs-chat"}
              headerBg="#0693e3"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to IMT!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-imt-bs-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#0693e3"
            />
          }
        />
        {/* widget-montpellier-bs */}
        <Route
          path="/widget-montpellier-bs"
          element={
            <ChatMeetWidget
              chatLink={"/widget-montpellier-bs-chat"}
              headerBg="#FFFFFF"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "black",
              }}
              welcomeMsg="Welcome to MBS!"
              subheadingStyle={{
                color: "black",
              }}
            />
          }
        />
        <Route
          path="/widget-montpellier-bs-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                    color: "black",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "black" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#FFFFFF"
            />
          }
        />
        {/* widget-junia */}
        <Route
          path="/widget-junia"
          element={
            <ChatMeetWidget
              chatLink={"/widget-junia-chat"}
              headerBg="#3f2a56"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to Junia!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-junia-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#3f2a56"
            />
          }
        />
        {/* widget-imd-nord-europe */}
        <Route
          path="/widget-imd-nord-europe"
          element={
            <ChatMeetWidget
              chatLink={"/widget-imd-nord-europe-chat"}
              headerBg="#1EB8DE"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to IMT Nord Europe!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-imd-nord-europe-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#1EB8DE"
            />
          }
        />

        {/* widget-ec-lyon */}
        <Route
          path="/widget-ec-lyon"
          element={
            <ChatMeetWidget
              chatLink={"/widget-ec-lyon-chat"}
              headerBg="#9c112a"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to L'École Centrale de Lyon"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-ec-lyon-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#9c112a"
            />
          }
        />
        {/* widget-em-strasbourg */}
        <Route
          path="/widget-em-strasbourg"
          element={
            <ChatMeetWidget
              chatLink={"/widget-em-strasbourg-chat"}
              headerBg="#e52621"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to EM Strasbourg!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-em-strasbourg-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#e52621"
            />
          }
        />
        {/* widget-essec */}
        <Route
          path="/widget-essec"
          element={
            <ChatMeetWidget
              chatLink={"/widget-essec-chat"}
              headerBg="#1da1e0"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to ESSEC!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-essec-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#1da1e0"
            />
          }
        />
        {/* widget-skema */}
        <Route
          path="/widget-skema"
          element={
            <ChatMeetWidget
              chatLink={"/widget-skema-chat"}
              headerBg="#e7514a"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to SKEMA Business School!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-skema-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#e7514a"
            />
          }
        />
        {/* widget-icn-artem */}
        <Route
          path="/widget-icn-artem"
          element={
            <ChatMeetWidget
              chatLink={"/widget-icn-artem-chat"}
              headerBg="#ff5400"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to ICN Business School"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-icn-artem-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#ff5400"
            />
          }
        />
        {/* widget-kedge */}
        <Route
          path="/widget-kedge"
          element={
            <ChatMeetWidget
              chatLink={"/widget-kedge-chat"}
              headerBg="#333539"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to KEDGE!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-kedge-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#333539"
            />
          }
        />
        {/* widget-excelia */}
        <Route
          path="/widget-excelia"
          element={
            <ChatMeetWidget
              chatLink={"/widget-excelia-chat"}
              headerBg="#164194"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to EXCELIA!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-excelia-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#164194"
            />
          }
        />
        {/* widget-essca */}
        <Route
          path="/widget-essca"
          element={
            <ChatMeetWidget
              chatLink={"/widget-essca-chat"}
              headerBg="#f0002c"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to ESSCA!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-essca-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#f0002c"
            />
          }
        />
        {/* widget-isae-supaero */}
        <Route
          path="/widget-isae-supaero"
          element={
            <ChatMeetWidget
              chatLink={"/widget-isae-supaero-chat"}
              headerBg="#05bdff"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to ISAE-SUPAERO!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-isae-supaero-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#05bdff"
            />
          }
        />
        {/* widget-devinci */}
        <Route
          path="/widget-devinci"
          element={
            <ChatMeetWidget
              chatLink={"/widget-devinci-chat"}
              headerBg="#9b51e0"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to De Vinci!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-devinci-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#9b51e0"
            />
          }
        />

        {/* widget-esigelec */}
        <Route
          path="/widget-esigelec"
          element={
            <ChatMeetWidget
              chatLink={"/widget-esigelec-chat"}
              headerBg="#17255a"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to ESIGELEC!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-esigelec-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#17255a"
            />
          }
        />
        {/* widget-cesi */}
        <Route
          path="/widget-cesi"
          element={
            <ChatMeetWidget
              chatLink={"/widget-cesi-chat"}
              headerBg="#fbe216"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "black",
              }}
              welcomeMsg="Welcome to CESI!"
              subheadingStyle={{
                color: "black",
              }}
            />
          }
        />
        <Route
          path="/widget-cesi-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                    color: "black",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                      color: "black",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "black" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#fbe216"
            />
          }
        />

        {/* widget-estp */}
        <Route
          path="/widget-estp"
          element={
            <ChatMeetWidget
              chatLink={"/widget-estp-chat"}
              headerBg="#479280"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to ESTP!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-estp-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#479280"
            />
          }
        />
        {/* widget-centrale-mediterranee */}
        <Route
          path="/widget-centrale-mediterranee"
          element={
            <ChatMeetWidget
              chatLink={"/widget-centrale-mediterranee-chat"}
              headerBg="#000F9F"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to Centrale Méditerranée!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-centrale-mediterranee-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#000F9F"
            />
          }
        />

        {/* widget-eurecom */}
        <Route
          path="/widget-eurecom"
          element={
            <ChatMeetWidget
              chatLink={"/widget-eurecom-chat"}
              headerBg="#239CD3"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to EURECOM!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-eurecom-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#239CD3"
            />
          }
        />
        {/* widget-isep */}
        <Route
          path="/widget-isep"
          element={
            <ChatMeetWidget
              chatLink={"/widget-isep-chat"}
              headerBg="#00629f"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to ISEP!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-isep-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#00629f"
            />
          }
        />
        {/* widget-dickinsonlaw */}
        <Route
          path="/widget-dickinsonlaw"
          element={
            <ChatMeetWidget
              chatLink={"/widget-dickinsonlaw-chat"}
              headerBg="#5C666F"
              logo="/dickinsonlaw-logo.jpeg"
              logoStyles={{ width: "170px", marginLeft: "-4px" }}
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to Dickinson Law!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-dickinsonlaw-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#5C666F"
            />
          }
        />

        {/* widget-univ-grenoble-alpes */}
        <Route
          path="/widget-univ-grenoble-alpes"
          element={
            <ChatMeetWidget
              chatLink={"/widget-univ-grenoble-alpes-chat"}
              headerBg="#162a42"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to Université Grenoble Alpes!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-univ-grenoble-alpes-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                    color: "white",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                      color: "white",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#162a42"
            />
          }
        />

        {/* widget-centralesupelec */}
        <Route
          path="/widget-centralesupelec"
          element={
            <ChatMeetWidget
              chatLink={"/widget-centralesupelec-chat"}
              headerBg="#961a3d"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to CentraleSupélec!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-centralesupelec-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#961a3d"
            />
          }
        />
        {/* widget-univ-lille */}
        <Route
          path="/widget-univ-lille"
          element={
            <ChatMeetWidget
              chatLink={"/widget-univ-lille-chat"}
              headerBg="#1F8389"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to Université de Lille!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-univ-lille-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#1F8389"
            />
          }
        />

        {/* widget-lafabrique-ecole */}
        <Route
          path="/widget-lafabrique-ecole"
          element={
            <ChatMeetWidget
              chatLink={"/widget-lafabrique-ecole-chat"}
              headerBg="#D93743"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to La Fabrique!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-lafabrique-ecole-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#D93743"
            />
          }
        />
        {/* widget-ecole-conte */}
        <Route
          path="/widget-ecole-conte"
          element={
            <ChatMeetWidget
              chatLink={"/widget-ecole-conte-chat"}
              headerBg="#E84428"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to Ecole Conte!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-ecole-conte-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#E84428"
            />
          }
        />
        {/* widget-sciencespo */}
        <Route
          path="/widget-sciencespo"
          element={
            <ChatMeetWidget
              chatLink={"/widget-sciencespo-chat"}
              headerBg="#e6142d"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to SciencesPo!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-sciencespo-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#e6142d"
            />
          }
        />
        {/* widget-iae-aix */}
        <Route
          path="/widget-iae-aix"
          element={
            <ChatMeetWidget
              chatLink={"/widget-iae-aix-chat"}
              headerBg="#911d37"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to IAE Aix-Marseille!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-iae-aix-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                    color: "white",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                      color: "white",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#911d37"
            />
          }
        />

        {/* widget-univ-tlse2 */}
        <Route
          path="/widget-univ-tlse2"
          element={
            <ChatMeetWidget
              chatLink={"/widget-univ-tlse2-chat"}
              headerBg="#5a9087"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to the University Toulouse - Jean Jaurès!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-univ-tlse2-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#5a9087"
            />
          }
        />
        {/* ////////////////////////////// */}
        {/* widget-icd-bs */}
        <Route
          path="/widget-icd-bs"
          element={
            <ChatMeetWidget
              chatLink={"/widget-icd-bs-chat"}
              headerBg="#cb212a"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to ICD Business School!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-icd-bs-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#cb212a"
            />
          }
        />
        {/* widget-em-normandie */}
        <Route
          path="/widget-em-normandie"
          element={
            <ChatMeetWidget
              chatLink={"/widget-em-normandie-chat"}
              headerBg="#FF0000"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to EM Normandie!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-em-normandie-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#FF0000"
            />
          }
        />
        {/* widget-ipsa */}
        <Route
          path="/widget-ipsa"
          element={
            <ChatMeetWidget
              chatLink={"/widget-ipsa-chat"}
              headerBg="#FF0000"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to IPSA!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-ipsa-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#FF0000"
            />
          }
        />
        {/* widget-ec-nantes */}
        <Route
          path="/widget-ec-nantes"
          element={
            <ChatMeetWidget
              chatLink={"/widget-ec-nantes-chat"}
              headerBg="#FFFFFF"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "black",
              }}
              welcomeMsg="Welcome to Centrale Nantes!"
              subheadingStyle={{
                color: "black",
              }}
            />
          }
        />
        <Route
          path="/widget-ec-nantes-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                    color: "black",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "black" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#FFFFFF"
            />
          }
        />
        {/* widget-imt-atlantique */}
        <Route
          path="/widget-imt-atlantique"
          element={
            <ChatMeetWidget
              chatLink={"/widget-imt-atlantique-chat"}
              headerBg="#00B5D5"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to IMT Atlantique!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-imt-atlantique-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#00B5D5"
            />
          }
        />
        {/* widget-em-lyon */}
        <Route
          path="/widget-em-lyon"
          element={
            <ChatMeetWidget
              chatLink={"/widget-em-lyon-chat"}
              headerBg="#e2001a"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "white",
              }}
              welcomeMsg="Welcome to Emlyon Business School!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />
        <Route
          path="/widget-em-lyon-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Chat with our students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#e2001a"
            />
          }
        />
        {/* ////////////////////////////// */}
        {/* france college fair route end */}
        {/* ! api test  */}
        <Route
          path="/widget-apitest"
          element={
            <TestWidget
              chatLink={"/widget-apitest-chat"}
              headerBg="white"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "black",
              }}
              logo="/ConnectLogo.png"
              logoStyles={{ width: "180px", marginLeft: "-14px" }}
              welcomeMsg="Welcome to CollegeIt"
              subheadingStyle={{
                color: "black",
              }}
            />
          }
        />
        <Route
          path="/widget-apitest-chat"
          element={
            <NewApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to CollegeIt's Law Students on WhatsApp!</span>
                </div>
              }
              university="uni1"
              headerColor="#111"
            />
          }
        />
        {/* ! api test */}
        <Route path="/lls" element={<LLSWidget />} />
        <Route
          path="/widget-umary"
          element={<ApiWidget header="Maryland" university="boston" />}
        />
        <Route
          path="/widget-stmarytx"
          element={<ApiWidget header="St. Mary's" university="boston" />}
        />

        <Route
          path="/widget-gwu"
          element={
            <ApiWidget
              header="GW LLM"
              university="boston"
              headerColor="#033c5a"
            />
          }
        />
        <Route
          path="/widget-umn"
          element={
            <ApiWidget
              header="UMN LLM"
              university="boston"
              headerColor="rgb(122 0 25)"
            />
          }
        />
        <Route
          path="/widget-wcl"
          element={
            <ApiWidget
              header="WCL's LLM"
              university="boston"
              headerColor="#003234"
            />
          }
        />
        <Route
          path="/widget-usc"
          element={
            <ChatMeetWidget
              chatLink={"/widget-usc-chat"}
              headerBg="#8C1A11"
              logo="/usc-gould-logo.png"
              logoStyles={{ width: "170px", marginLeft: "-4px" }}
              welcomeMsg="Welcome to USC Gould School of Law!"
            />
          }
        />

        <Route
          path="/widget-ucla"
          element={
            <ChatMeetWidget
              chatLink={"/widget-ucla-chat"}
              headerBg="#1E92EB"
              headingStyle={{
                fontSize: "30px",
                fontWeight: "600",
              }}
              logo="/ucla-law-logo.png"
              logoStyles={{ width: "180px", marginLeft: "-20px" }}
              welcomeMsg="Welcome to UCLA Law!"
            />
          }
        />
        <Route
          path="/widget-temple"
          element={
            <ChatMeetWidget
              chatLink={"/widget-temple-chat"}
              headerBg="white"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "black",
              }}
              logo="/temple-logo.png"
              logoStyles={{ width: "160px", marginLeft: "0px" }}
              welcomeMsg="Welcome to Temple University!"
              subheadingStyle={{
                color: "black",
              }}
            />
          }
        />
        <Route
          path="/widget-usd"
          element={
            <ChatMeetWidget
              chatLink={"/widget-usd-chat"}
              headerBg="#003b70"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
              }}
              logo="/usd-logo.png"
              logoStyles={{ width: "280px", marginLeft: "-16px" }}
              welcomeMsg="Welcome to University of San Diego!"
              subheadingStyle={{}}
            />
          }
        />

        <Route
          path="/widget-wlu"
          element={
            <ChatMeetWidget
              chatLink={"/widget-wlu-chat"}
              headerBg="#002a4f"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
              }}
              logo="/wlu-logo.svg"
              logoStyles={{ width: "103px", marginLeft: "-4px" }}
              welcomeMsg="Welcome to W&L Law School!"
              subheadingStyle={{}}
            />
          }
        />
        <Route
          path="/widget-wlu-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to W&L Law&apos;s Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#002a4f"
            />
          }
        />

        <Route
          path="/widget-frankfurt"
          element={
            <ChatMeetWidget
              chatLink={"/widget-frankfurt-chat"}
              headerBg="white"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "black",
              }}
              logo="/frankfurt-logo.svg"
              logoStyles={{ height: "60px", marginLeft: "-4px" }}
              welcomeMsg="Welcome to Institute for Law and Finance!"
              subheadingStyle={{
                color: "black",
              }}
            />
          }
        />
        <Route
          path="/widget-frankfurt-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to ILF&apos;s Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#005aa9"
            />
          }
        />
        <Route
          path="/widget-gw"
          element={
            <ChatMeetWidget
              chatLink={"/widget-gw-chat"}
              headerBg="white"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "black",
              }}
              logo="/gw-logo.png"
              logoStyles={{ width: "150px", marginLeft: "-4px" }}
              welcomeMsg="Welcome to GW Law!"
              subheadingStyle={{
                color: "black",
              }}
            />
          }
        />
        <Route
          path="/widget-gw-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to GW Law&apos;s Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#033c5a"
            />
          }
        />

        <Route
          path="/widget-vanderbilt"
          element={
            <ChatMeetWidget
              chatLink={"/widget-vanderbilt-chat"}
              headerBg="#111"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
              }}
              logo="/vanderbilt-logo.svg"
              logoStyles={{ width: "180px", marginLeft: "-4px" }}
              welcomeMsg="Welcome to Vanderbilt Law School!"
              subheadingStyle={{}}
            />
          }
        />
        <Route
          path="/widget-vanderbilt-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to Vanderbilt's Law Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#111"
            />
          }
        />
        <Route
          path="/widget-smu"
          element={
            <ChatMeetWidget
              chatLink={"/widget-smu-chat"}
              headerBg="#354ca1"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
              }}
              logo="/smu-logo.png"
              logoStyles={{ width: "250px", marginLeft: "-4px" }}
              welcomeMsg="Welcome to SMU Dedman Law!"
              subheadingStyle={{}}
            />
          }
        />
        <Route
          path="/widget-smu-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span style={{ fontSize: "20px" }}>
                    Speak to SMU Dedman Law's Students on WhatsApp!
                  </span>
                </div>
              }
              university="boston"
              headerColor="#354ca1"
            />
          }
        />

        <Route
          path="/widget-kingston"
          element={
            <ChatMeetWidget
              chatLink={"/widget-kingston-chat"}
              headerBg="#111"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
              }}
              logo="/kingston-logo.png"
              logoStyles={{ width: "110px", marginLeft: "-4px" }}
              welcomeMsg="Welcome to Kingston University London!"
              subheadingStyle={{}}
            />
          }
        />
        <Route
          path="/widget-kingston-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to Kingston's LLM Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#111"
            />
          }
        />

        <Route
          path="/widget-au"
          element={
            <ChatMeetWidget
              chatLink={"/widget-au-chat"}
              headerBg="white"
              headingStyle={{
                fontSize: "27px",
                fontWeight: "600",
                color: "black",
              }}
              logo="/au-logo.svg"
              logoStyles={{ width: "200px", marginLeft: "-4px" }}
              welcomeMsg="Welcome to the School of Public Affairs!"
              subheadingStyle={{
                color: "black",
              }}
            />
          }
        />
        <Route
          path="/widget-au-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to SPA Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#111"
            />
          }
        />

        <Route
          path="/widget-usd-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to USD's Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#003b70"
            />
          }
        />
        <Route
          path="/widget-temple-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to TU's Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#a41e35"
            />
          }
        />
        <Route
          path="/widget-uci"
          element={
            <ChatMeetWidget
              chatLink={"/widget-uci-chat"}
              headerBg="#275799"
              headingStyle={{
                fontSize: "30px",
                fontWeight: "600",
              }}
              logo="/uci-law-logo.png"
              logoStyles={{
                width: "180px",
                marginLeft: "-2px",
                padding: "10px",
                border: "1px solid white",
              }}
              welcomeMsg="Welcome to UCI Law!"
            />
          }
        />
        <Route
          path="/widget-osgoode"
          element={
            <ChatMeetWidget
              chatLink={"/widget-osgoode-chat"}
              headerBg="white"
              headingStyle={{
                fontSize: "30px",
                fontWeight: "600",
                color: "black",
              }}
              logo="/osgoode-logo.png"
              logoStyles={{
                width: "190px",
                marginLeft: "-2px",
              }}
              subheadingStyle={{ color: "black" }}
              welcomeMsg="Welcome to Osgoode Hall Law!"
            />
          }
        />

        <Route
          path="/widget-osgoode-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to Osgoode Hall's Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#bb152f"
            />
          }
        />
        <Route
          path="/widget-uci-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>
                    Speak to UCI's Students <br /> on WhatsApp!
                  </span>
                </div>
              }
              university="boston"
              headerColor="#275799"
            />
          }
        />
        <Route
          path="/widget-ucla-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to UCLA's Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#1E92EB"
            />
          }
        />

        <Route
          path="/widget-usc-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to USC Gould's Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#900"
            />
          }
        />

        <Route
          path="/widget-delaware"
          element={
            <ChatMeetWidget
              chatLink={"/widget-delaware-chat"}
              headerBg="#20366B"
              headingStyle={{
                fontSize: "30px",
                fontWeight: "600",
              }}
              logo="/delaware_logo.png"
              logoStyles={{
                width: "150px",
                height: "30px",
                marginLeft: "0px",
                marginBottom: "5px",
              }}
              welcomeMsg="Welcome to Delaware Law School!"
            />
          }
        />

        <Route
          path="/widget-delaware-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to Delaware's Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#1E92EB"
            />
          }
        />

        {/* seattle law */}
        <Route
          path="/widget-seattle-law"
          element={
            <ChatMeetWidget
              chatLink={"/widget-seattle-law-chat"}
              headerBg="#AA0101"
              headingStyle={{
                fontSize: "30px",
                fontWeight: "600",
              }}
              logo="/seattle_law_bg.png"
              logoStyles={{
                width: "120px",
                height: "40px",
                marginLeft: "0px",
                marginBottom: "5px",
              }}
              welcomeMsg="Welcome to Seattle Law School!"
            />
          }
        />

        <Route
          path="/widget-seattle-law-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to Seattle's Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#1E92EB"
            />
          }
        />

        {/* bu law */}

        <Route
          path="/widget-bu-law"
          element={
            <ChatMeetWidget
              chatLink={"/widget-bu-chat"}
              headerBg="#FFFFFF"
              headingStyle={{
                fontSize: "30px",
                fontWeight: "600",
                color: "#000000",
              }}
              logo="/bu_law.jpeg"
              logoStyles={{
                width: "180px",
                height: "90px",
                marginLeft: "-18px",
              }}
              welcomeMsg="Welcome to BU Law!"
              subheadingStyle={{
                color: "black",
                marginLeft: "2px",
              }}
            />
          }
        />

        <Route
          path="/widget-bu-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "black" }} />
                  </IconButton>
                  <span>Speak to BU's Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#1E92EB"
            />
          }
        />

        {/* minnesota */}
        <Route
          path="/widget-minnesota-law"
          element={
            <ChatMeetWidget
              chatLink={"/widget-minnesota-chat"}
              headerBg="#790119"
              headingStyle={{
                fontSize: "30px",
                fontWeight: "600",
                color: "white",
              }}
              logo="/sites/header_bg.jpeg"
              logoStyles={{
                width: "240px",
                height: "40px",
                marginTop: "15px",
                marginLeft: "-5px",
              }}
              welcomeMsg="Welcome to Minnesota Law!"
              subheadingStyle={{
                color: "white",
              }}
            />
          }
        />

        <Route
          path="/widget-minnesota-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to Minnesota's Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#790119"
            />
          }
        />

        {/* emory */}

        <Route
          path="/widget-emory"
          element={
            <ChatMeetWidget
              chatLink={"/widget-emory-chat"}
              headerBg="#012169"
              headingStyle={{
                fontSize: "30px",
                fontWeight: "600",
              }}
              logo="/emory_logo.jpeg"
              logoStyles={{
                width: "170px",
                height: "40px",
                marginLeft: "0px",
                marginBottom: "5px",
              }}
              welcomeMsg="Welcome to Emory Law!"
            />
          }
        />

        <Route
          path="/widget-emory-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to Emory's Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#1E92EB"
            />
          }
        />

        {/* ucr */}
        <Route
          path="/widget-ucr"
          element={
            <ChatMeetWidget
              chatLink={"/widget-ucr-chat"}
              headerBg="#002D93"
              headingStyle={{
                fontSize: "30px",
                fontWeight: "600",
              }}
              logo="/ucr_logo.svg"
              logoStyles={{
                width: "170px",
                height: "60px",
                marginLeft: "-55px",
                marginBottom: "5px",
              }}
              welcomeMsg="Welcome to UCR School of Business!"
            />
          }
        />

        <Route
          path="/widget-ucr-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to UCR's Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="#1E92EB"
            />
          }
        />

        {/* oneill */}
        <Route
          path="/widget-oneill"
          element={
            <ChatMeetWidget
              chatLink={"/widget-oneill-chat"}
              headerBg="#FFFFFF"
              headingStyle={{
                fontSize: "30px",
                fontWeight: "600",
                color: "#000000",
              }}
              logo="/oneill.png"
              logoStyles={{
                width: "60px",
                height: "70px",
                marginLeft: "0px",
                marginBottom: "5px",
              }}
              welcomeMsg="Welcome to O'Neill School!"
              subheadingStyle={{
                color: "black",
                marginLeft: "2px",
              }}
            />
          }
        />

        <Route
          path="/widget-oneill-chat"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>Speak to O'Neill School Students on WhatsApp!</span>
                </div>
              }
              university="boston"
              headerColor="black"
            />
          }
        />

        <Route
          path="/widget-dickinson"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <>
                  Speak to Penn State <br /> students on WhatsApp
                </>
              }
              logo="/dickinsonlaw-logo.jpeg"
              logoStyles={{ width: "170px", marginLeft: "-4px" }}
              university="boston"
              headerColor="#415463"
            />
          }
        />
        <Route
          path="/widget-kent"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <>
                  Speak to Kent Law Students <br /> on WhatsApp!
                </>
              }
              university="boston"
              headerColor="#cc0000"
            />
          }
        />

        <Route path="/llm-demo" element={<LLM />} />
        <Route path="/widget-bak" element={<Widget />} />
        <Route
          path="/widget"
          element={
            <ApiWidget
              header={false}
              headerElement={
                <>
                  Speak to TAU LLM Students <br /> on WhatsApp!
                </>
              }
              university="telaviv"
              headerColor="black"
            />
          }
        />
        <Route
          path="/widget-lls"
          element={
            <ApiWidget
              university="boston"
              headerColor="#ab0c2f"
              header={false}
              headerElement={
                <div
                  style={{
                    position: "relative",
                    padding: "0 0 0 26px",
                  }}
                >
                  <IconButton
                    style={{
                      position: "fixed",
                      left: 0,
                      top: "12px",
                    }}
                    onClick={() => goBack()}
                  >
                    <ArrowBackIcon style={{ color: "white" }} />
                  </IconButton>
                  <span>
                    Speak to LLS Students <br /> on WhatsApp!
                  </span>
                </div>
              }
            />
          }
        />
      </Routes>
    </div>
  );
}

export default App;
